import React from 'react';
import queryString from 'query-string';

import { Nav } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';

function SideNav({ links, defaultActive, classes, history, location }) {
  const qString = queryString.parse(location.search);
  const handleNavigation = (route) => {
    history.push(`/?page=&category=${route}&search=${qString.search}&productTypes=${qString.productTypes}`);
  }

  return (
    <Nav defaultActiveKey={defaultActive} className={`flex-column ${classes ? classes : ''}`}>
      {links.map((link, index) => {
        if (link.title) {
          return <Nav.Link key={index}
            onClick={handleNavigation.bind(null, link.route)}
            className={`
          ${qString.category === link.title.toLowerCase() ? 'active' :
          (qString.category === '' && link.title.toLowerCase() === 'all') || (qString.category === 'all' && link.title.toLowerCase() === 'alt')  ?
                  'active' : ''}`}>
            {link.title}
          </Nav.Link>
          }
          else {
            return null
          }
      })}
    </Nav>
  );
}

export default withRouter(SideNav);